"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "collesalvetti": {
    "77400b45": [{
      "hkey": "9564a0ac",
      "slug": "castell-anselmo-torretta-vecchia",
      "name": "Castell'Anselmo-Torretta Vecchia",
      "primary": true,
      "skipSearch": false
    }],
    "castell-anselmo": [{
      "hkey": "9564a0ac",
      "slug": "castell-anselmo-torretta-vecchia",
      "name": "Castell'Anselmo-Torretta Vecchia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;